import React from 'react';
import { CerebroAutoComplete, CerebroAutoCompleteProps } from '../../shared/components';
import { BaseLender, Guid, PartialBank } from '../../shared/models';
import { useDebounce } from '../../shared/hooks';
import { useBankPartialsQuery } from '../../shared/hooks/Queries/useBankPartialsQuery';

export type LendersAutoCompleteProps = CerebroAutoCompleteProps<PartialBank, false, false, false> & {
	companyGuid?: Guid;
	lenders: BaseLender[];
};

export const LendersAutoComplete: React.FC<LendersAutoCompleteProps> = ({ companyGuid, lenders, ...props }) => {
	const [inputValue, setInputValue] = React.useState('');

	const search = useDebounce(inputValue, 200);

	const bankPartialsQuery = useBankPartialsQuery(search, companyGuid);

	const options =
		bankPartialsQuery.data?.filter(partialBank => lenders.every(lender => lender.bankGuid !== partialBank.guid)) ??
		[];

	return (
		<CerebroAutoComplete
			{...props}
			placeholder="Search for a lender by name"
			clearOnEscape
			loading={bankPartialsQuery.isFetching}
			options={options}
			isOptionEqualToValue={(option: PartialBank, value: PartialBank) => option.guid === value.guid}
			getOptionLabel={(bank: PartialBank) => bank.name}
			onInputChange={(_, newInputValue) => {
				setInputValue(newInputValue);
			}}
		/>
	);
};
